<app-multiple-select-filter-data
        [additionalUrlParameters]="additionalUrlParameters"
        [filterElementProcessor]="filter"
        [newItemModalOptions]="newPainModalOptions()"
        [parentFormControlName]="parentFormControlName"
        [parentFormGroup]="parentFormGroup"
        [resolveSelectFilterElement]="resolveSelectFilterElement"
        [loadOnInit]="true"
        [service]="service"
>
    <ng-template let-element='element' template-content>
        {{element.toString()}}
    </ng-template>
</app-multiple-select-filter-data>